import { render, staticRenderFns } from "./festivos.vue?vue&type=template&id=5727acb6&scoped=true"
import script from "./festivos.vue?vue&type=script&lang=js"
export * from "./festivos.vue?vue&type=script&lang=js"
import style0 from "./festivos.vue?vue&type=style&index=0&id=5727acb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5727acb6",
  null
  
)

export default component.exports